(function () {
  const HOME_PATH = "/";
  const B2B_PATH = "/pages/third-party-ayurvedic-manufacturing";
  const TRACK_ORDER_PATH = "/pages/track-your-order";
  const SUPPORT_PHONE = "+91 9996202020";
  const SUPPORT_PHONE_DIGITS = "919996202020";
  const SUPPORT_EMAIL = "contact@nutravel.in";
  const WHATSAPP_URL = `https://wa.me/${SUPPORT_PHONE_DIGITS}?text=${encodeURIComponent("Hello Nutravel, I would like help choosing the right product.")}`;
  const TRACKING_CONFIG = window.NUTRAVEL_TRACKING_CONFIG || {};
  const TRACKING_PROXY_URL = TRACKING_CONFIG.endpoint || "";
  const TRACKING_SHOP = window.Shopify?.shop || "270fd8-2.myshopify.com";
  const POSTSHIP_STATUS_URL = "https://postship.instasell.co.in/_/get_order_status";
  const TRACKING_NUMBER_URL = "https://t.17track.net/en#nums=";
  const CATEGORY_LINKS = [
    { href: "/collections/capsules", label: "Capsules" },
    { href: "/collections/sryups", label: "Syrups" },
    { href: "/collections/powder", label: "Powders" },
    { href: "/collections/pain-relief", label: "Relief Oils" },
  ];
  const TRUST_POINTS = [
    { title: "Ayurvedic formulations", body: "Clean everyday products across oils, capsules, powders, and syrups." },
    { title: "Support that converts", body: "Faster product guidance and clearer buying decisions across the storefront." },
    { title: "Backed by Nutravel", body: "A direct brand experience with manufacturing strength behind the catalog." },
  ];
  const TRACKING_TRUST_POINTS = [
    { title: "Secure order lookup", body: "Track by order number and the contact used at checkout for a calmer verification flow." },
    { title: "Dispatch-to-delivery visibility", body: "See the latest courier movement, shipping progress, and status messaging in one place." },
    { title: "Priority support on WhatsApp", body: "If an order is delayed or missing, Nutravel support stays easy to reach." },
  ];
  const TRACKING_STAGES = [
    { step: "01", title: "Order confirmed", body: "Your order is received and prepared for dispatch verification." },
    { step: "02", title: "Dispatched", body: "Shipping details are linked once the courier pickup is completed." },
    { step: "03", title: "In transit", body: "Movement updates begin appearing as the parcel travels through courier checkpoints." },
    { step: "04", title: "Out for delivery", body: "Final-mile updates show once the order is close to your doorstep." },
  ];
  const FACTORY_GALLERY = [
    {
      file: "nutravel-factory-mixing.jpg",
      title: "Precision formulation",
      body: "Large-batch blending and monitored formulation help maintain consistency across Ayurvedic product development.",
    },
    {
      file: "nutravel-factory-decoction.jpg",
      title: "Traditional process care",
      body: "Classical preparation methods are handled with disciplined supervision and a clean production environment.",
    },
    {
      file: "nutravel-factory-quality-control.jpg",
      title: "Quality checks",
      body: "Inspection, filling, and batch handling are structured around controlled workflow and documented review.",
    },
    {
      file: "nutravel-factory-sealing.jpg",
      title: "Finishing and sealing",
      body: "Packaging steps are managed inside dedicated clean areas for stronger presentation and dependable output.",
    },
    {
      file: "nutravel-factory-pouch-line.jpg",
      title: "Automated packing support",
      body: "Modern equipment supports repeatable pouch and unit packing for partner-ready manufacturing projects.",
    },
    {
      file: "nutravel-factory-blister-line.jpg",
      title: "Production equipment",
      body: "Dedicated machinery supports organized throughput for capsules, tablets, and finished packaging formats.",
    },
    {
      file: "nutravel-factory-vessels.png",
      title: "Controlled vessel room",
      body: "Stainless steel process vessels and monitored controls support repeatable batch handling within a structured room setup.",
    },
    {
      file: "nutravel-factory-inspection-room.jpg",
      title: "Inspection room",
      body: "Product review and line checks are carried out in clean, dedicated spaces designed for monitored handling.",
    },
    {
      file: "nutravel-factory-corridor.jpg",
      title: "Facility circulation",
      body: "Internal corridors connect production and storage areas through a visibly ordered facility layout.",
    },
    {
      file: "nutravel-factory-tablet-press.jpg",
      title: "Compression review",
      body: "Machine-side review and process observation support careful handling around solid-dose production equipment.",
    },
    {
      file: "nutravel-factory-filling-line.jpg",
      title: "Filling line",
      body: "Filled units are checked and managed inside dedicated production sections that support batch-oriented output.",
    },
    {
      file: "nutravel-factory-office.jpg",
      title: "Office support",
      body: "Administrative and support teams operate alongside manufacturing to coordinate partners, documentation, and workflow.",
    },
    {
      file: "nutravel-factory-entrance.jpg",
      title: "Facility entrance",
      body: "A clean front-facing entry helps present the plant environment with greater professionalism for visiting partners.",
    },
    {
      file: "nutravel-factory-lounge.jpg",
      title: "Founder and compliance wall",
      body: "The reception and visitor area adds context around Nutravel's leadership, certifications, and business presence.",
    },
  ];

  const COLLECTION_INTROS = {
    capsules:
      "Discover focused Ayurvedic capsule rituals with a calmer, cleaner browsing experience for daily wellness.",
    sryups:
      "Traditional syrups and tonics, presented with clearer hierarchy and a more premium product rhythm.",
    powder:
      "Classical powders and herbal formulations for ritual-led wellness, grounded in a quieter editorial presentation.",
    "pain-relief":
      "Targeted oils and topical care, refined into an easier, more elegant shopping flow.",
    shop:
      "Explore the full Nutravel collection through a more balanced, polished, and product-first storefront.",
  };

  const PRODUCT_PANEL_COPY = {
    ashwagandha: {
      eyebrow: "Daily ritual",
      summary: "A composed everyday essential for steady wellness, balance, and a cleaner buying experience.",
    },
    triphala: {
      eyebrow: "Digestive balance",
      summary: "A more elegant daily wellness presentation for digestive rhythm, lightness, and routine support.",
    },
    giloy: {
      eyebrow: "Everyday support",
      summary: "A grounded herbal staple for daily resilience, presented with calmer hierarchy and improved clarity.",
    },
  };
  const MILESTONES = [
    { key: "shipping", minSubtotal: 34900, label: "Free shipping" },
    { key: "discount", minSubtotal: 49900, label: "10% off" },
    { key: "gift", minSubtotal: 59900, label: "Long Jatta sample pack" },
  ];
  const FREE_GIFT = {
    handle: "long-jatta-sample-pack",
    productId: 8939946508509,
    variantId: 46248431386845,
    catalogPrice: 10000,
    title: "Long Jatta Sample Pack",
  };
  const SHIPPING_PROTECTION = {
    handle: "shipping-protection",
    title: "Shipping Protection",
  };

  const VISUAL_BLOCKERS = [
    "#rfPopsContainer",
    "#smsbump-form-308312",
    '[id^="smsbump-form-"]',
    ".yotpo-smsbump-modal__backdrop",
    ".yotpo-smsbump-modal__content",
    ".sc-151px96-0.cBcGnh",
    ".sc-gjt4dd-0.ctVBqw",
    ".Avada-Faqs_Button",
    ".Avada-Preview_Button",
    ".Avada-Preview_Popup",
    ".Avada-Joy_ButtonWidget",
    ".shiprocket-chat-widget",
  ];

  const OVERLAY_BLOCKERS = [
    "#shiprocket-mini-cart-overlay",
    ".shiprocket-mini-cart-overlay",
  ];

  const STATE = {
    observers: [],
    reducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    cleanupTimer: null,
    sceneTimer: null,
    maintenanceTimer: null,
    maintenanceQueued: false,
    cartState: null,
    cartPromise: null,
    cartRefreshTimer: null,
    fastRRPolishTimer: null,
    giftAutomationBlocked: false,
  };
  const SCRIPT_URL = document.currentScript && document.currentScript.src ? document.currentScript.src : "";
  const ASSET_BASE = SCRIPT_URL ? SCRIPT_URL.replace(/nutravel-redesign\.js(?:\?.*)?$/, "") : "";

  function isHomepage() {
    return window.location.pathname === HOME_PATH;
  }

  function isCollection() {
    return window.location.pathname.indexOf("/collections/") === 0;
  }

  function isProduct() {
    return window.location.pathname.indexOf("/products/") === 0;
  }

  function isB2B() {
    return window.location.pathname.indexOf(B2B_PATH) === 0;
  }

  function isTrackOrder() {
    return window.location.pathname.indexOf(TRACK_ORDER_PATH) === 0;
  }

  function compactTitle(title) {
    if (!title) return "";

    let cleaned = title
      .replace(/\s+-\s+Nutravel$/i, "")
      .replace(/\s+-\s+Pack of \d+$/i, "")
      .replace(/\s*\|\s*Nutravel$/i, "")
      .replace(/\s{2,}/g, " ")
      .trim();

    if (cleaned.includes("|")) cleaned = cleaned.split("|")[0].trim();
    return cleaned;
  }

  function getProductCopy(titleText) {
    const title = (titleText || "").toLowerCase();

    if (title.includes("ashwagandha")) return PRODUCT_PANEL_COPY.ashwagandha;
    if (title.includes("triphala")) return PRODUCT_PANEL_COPY.triphala;
    if (title.includes("giloy")) return PRODUCT_PANEL_COPY.giloy;

    return {
      eyebrow: "Premium wellness",
      summary: "A calmer retail presentation for clearer product understanding and a more confident buying flow.",
    };
  }

  function addBodyFlags() {
    document.body.classList.toggle("nutravel-home-template", isHomepage());
    document.body.classList.toggle("nutravel-collection-template", isCollection());
    document.body.classList.toggle("nutravel-product-template", isProduct());
    document.body.classList.toggle("nutravel-b2b-template", isB2B());
    document.body.classList.add("nutravel-editorial-lux");
  }

  function hideElement(node) {
    if (!node) return;
    node.style.setProperty("display", "none", "important");
    node.style.setProperty("visibility", "hidden", "important");
    node.setAttribute("aria-hidden", "true");
  }

  function cleanupVisualBlockers() {
    VISUAL_BLOCKERS.forEach((selector) => {
      document.querySelectorAll(selector).forEach(hideElement);
    });
  }

  function cleanupOverlayBlockers() {
    OVERLAY_BLOCKERS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        node.classList.remove("active", "open", "is-active");
        node.style.setProperty("opacity", "0", "important");
        node.style.setProperty("visibility", "hidden", "important");
        node.style.setProperty("pointer-events", "none", "important");
      });
    });

    document.querySelectorAll("dialog").forEach((dialog) => {
      const text = dialog.textContent || "";
      if (text.includes("10% off your next order") || text.includes("Join us!")) {
        dialog.removeAttribute("open");
        hideElement(dialog);
      }
    });
  }

  function hasLegitModalOpen() {
    const legitSelectors = [
      'dialog[open]:not([aria-hidden="true"])',
      'details[open].menu-opening',
      '.drawer.active',
      '.drawer.animate.active',
      '.product-media-modal[open]',
      '.quick-add-modal[open]',
      '.facets__disclosure[open]',
    ];

    return legitSelectors.some((selector) =>
      Array.from(document.querySelectorAll(selector)).some((node) => getComputedStyle(node).display !== "none")
    );
  }

  function ensureScrollUnlocked() {
    if (hasLegitModalOpen()) return;

    const htmlStyle = getComputedStyle(document.documentElement);
    const bodyStyle = getComputedStyle(document.body);
    const htmlLocked = htmlStyle.overflow === "hidden" || htmlStyle.overflowY === "hidden";
    const bodyLocked = bodyStyle.overflow === "hidden" || bodyStyle.overflowY === "hidden";

    if (htmlLocked) {
      document.documentElement.style.overflow = "";
      document.documentElement.style.overflowY = "";
    }

    if (bodyLocked) {
      document.body.style.overflow = "";
      document.body.style.overflowY = "";
    }

    document.body.classList.remove("overflow-hidden", "modal-open");
    document.documentElement.classList.remove("overflow-hidden", "modal-open");
  }

  function safelyWrapMethod(tagName, methodName) {
    const constructor = window.customElements?.get(tagName);
    const proto = constructor?.prototype;
    const original = proto?.[methodName];

    if (typeof original !== "function" || original.__nutravelWrapped) return;

    const wrapped = function (...args) {
      try {
        return original.apply(this, args);
      } catch (error) {
        return undefined;
      }
    };

    wrapped.__nutravelWrapped = true;
    proto[methodName] = wrapped;
  }

  function patchThemeRuntime() {
    safelyWrapMethod("slideshow-component", "applyAnimationToAnnouncementBar");
    safelyWrapMethod("slideshow-component", "autoRotateSlides");
    safelyWrapMethod("cart-drawer", "setHeaderCartIconAccessibility");
  }

  function hasFastRRDrawer() {
    return Boolean(document.querySelector("#shiprocket-mini-cart-container")) && Boolean(document.querySelector("#cart-icon-bubble-sr"));
  }

  function openFastRRDrawer() {
    if (!hasFastRRDrawer()) return false;

    document.body.classList.add("nutravel-use-fastrr-cart");

    const nativeDrawer = document.querySelector("#CartDrawer");
    const nativeOverlay = document.querySelector("#CartDrawer-Overlay");
    if (nativeDrawer) {
      nativeDrawer.classList.remove("active", "is-active", "animate", "animate-active");
      nativeDrawer.setAttribute("aria-hidden", "true");
    }
    if (nativeOverlay) nativeOverlay.style.setProperty("display", "none", "important");

    const mini = document.querySelector("#shiprocket-mini-cart-container");
    const overlay = document.querySelector("#shiprocket-mini-cart-overlay");
    const cartBubble = document.querySelector("#cart-icon-bubble-sr");

    if (mini && getComputedStyle(mini).display !== "none" && getComputedStyle(mini).visibility !== "hidden") {
      return true;
    }

    if (cartBubble) {
      cartBubble.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
      return true;
    }

    if (mini) {
      mini.style.setProperty("display", "block", "important");
      mini.style.setProperty("visibility", "visible", "important");
      mini.style.setProperty("pointer-events", "auto", "important");
    }
    if (overlay) {
      overlay.style.setProperty("display", "block", "important");
      overlay.style.setProperty("visibility", "visible", "important");
      overlay.style.setProperty("opacity", "1", "important");
      overlay.style.setProperty("pointer-events", "auto", "important");
    }

    return true;
  }

  function bindFastRRCartBridge() {
    if (!hasFastRRDrawer() || document.body.dataset.nutravelFastrrBound) return;

    document.body.classList.add("nutravel-use-fastrr-cart");

    document.addEventListener(
      "click",
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const nativeCartTrigger = target.closest(
          'a[href=\"/cart\"], a[href*=\"/cart\"], button[name=\"add\"], .quick-add__submit, .product-form__submit, .header__icon--cart:not(#cart-icon-bubble-sr), [data-cart-open]'
        );

        if (!nativeCartTrigger) return;

        const isFastRRButton = target.closest("#cart-icon-bubble-sr, .mini-cart-add-to-cart-btn, .mini-cart-order-btn, .sr-headless-checkout");
        if (isFastRRButton) return;

        const href = nativeCartTrigger.getAttribute("href") || "";
        const looksLikeCartLink = /\/cart/.test(href);

        if (looksLikeCartLink) {
          event.preventDefault();
          openFastRRDrawer();
          requestCartRefresh(120, true);
          return;
        }

        window.setTimeout(() => {
          openFastRRDrawer();
          requestCartRefresh(1400, true);
        }, 900);
      },
      true
    );

    document.body.dataset.nutravelFastrrBound = "true";
  }

  function getFastRRItemQuantity(item) {
    if (!item) return 0;

    const numericField = item.querySelector(
      'input[type="number"], input[type="text"].mini-cart-item-qty, input[name*="quantity"], .mini-cart-item-qty'
    );
    if (numericField) {
      const rawValue =
        "value" in numericField && typeof numericField.value === "string"
          ? numericField.value
          : numericField.textContent || "";
      const parsed = Number.parseInt(rawValue, 10);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }

    const quantityTextNode = item.querySelector(
      ".mini-cart-item-qty, .mini-cart-qty-value, .mini-cart-item-quantity, .mini-cart-item-price"
    );
    const quantityText = quantityTextNode ? quantityTextNode.textContent : item.textContent;
    const match = quantityText && quantityText.match(/\bx\s*(\d+)\b/i);
    if (match) {
      const parsed = Number.parseInt(match[1], 10);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }

    return 1;
  }

  function parseCurrencyValue(text) {
    const cleaned = String(text || "")
      .replace(/,/g, "")
      .match(/₹\s*([0-9]+(?:\.[0-9]+)?)/);
    return cleaned ? Number.parseFloat(cleaned[1]) : 0;
  }

  function formatCurrencyFromCents(cents) {
    const safeValue = Number.isFinite(cents) ? cents : 0;
    return `Rs ${Math.max(0, safeValue / 100).toFixed(0)}`;
  }

  function isFreeGiftLine(item) {
    if (!item) return false;
    const variantId = Number(item.variant_id || item.id || 0);
    const handle = String(item.handle || "").toLowerCase();
    const title = String(item.product_title || item.title || "").toLowerCase();
    return variantId === FREE_GIFT.variantId || handle === FREE_GIFT.handle || title.includes(FREE_GIFT.title.toLowerCase());
  }

  function isShippingProtectionLine(item) {
    if (!item) return false;
    const handle = String(item.handle || "").toLowerCase();
    const title = String(item.product_title || item.title || "").toLowerCase();
    return handle === SHIPPING_PROTECTION.handle || title.includes(SHIPPING_PROTECTION.title.toLowerCase());
  }

  function getLineSubtotal(item) {
    if (!item) return 0;
    if (Number.isFinite(item.final_line_price)) return item.final_line_price;
    if (Number.isFinite(item.line_price)) return item.line_price;
    const unitPrice = Number.isFinite(item.final_price) ? item.final_price : Number.isFinite(item.price) ? item.price : 0;
    const quantity = Number.isFinite(item.quantity) ? item.quantity : 1;
    return unitPrice * quantity;
  }

  function deriveCartMilestoneState(cart = null) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const qualifyingItems = items.filter((item) => !isFreeGiftLine(item) && !isShippingProtectionLine(item));
    const qualifyingSubtotal = qualifyingItems.reduce((total, item) => total + getLineSubtotal(item), 0);
    const shippingUnlocked = qualifyingSubtotal >= MILESTONES[0].minSubtotal;
    const discountUnlocked = qualifyingSubtotal >= MILESTONES[1].minSubtotal;
    const giftUnlocked = qualifyingSubtotal >= MILESTONES[2].minSubtotal;
    const freeGiftItem = items.find((item) => isFreeGiftLine(item)) || null;
    const freeGiftTrulyFree = freeGiftItem ? getLineSubtotal(freeGiftItem) === 0 : false;
    const topThreshold = MILESTONES[MILESTONES.length - 1].minSubtotal;
    const progress = topThreshold > 0 ? Math.min(100, Math.round((qualifyingSubtotal / topThreshold) * 100)) : 0;
    const nextMilestone = MILESTONES.find((milestone) => qualifyingSubtotal < milestone.minSubtotal) || null;
    const remaining = nextMilestone ? Math.max(0, nextMilestone.minSubtotal - qualifyingSubtotal) : 0;
    const actualCartSavings = Math.max(0, Number(cart?.original_total_price || 0) - Number(cart?.total_price || 0));

    return {
      cart,
      items,
      qualifyingSubtotal,
      shippingUnlocked,
      discountUnlocked,
      giftUnlocked,
      freeGiftItem,
      freeGiftTrulyFree,
      progress,
      nextMilestone,
      remaining,
      actualCartSavings,
      giftAutomationAvailable: false,
    };
  }

  function deriveMiniCartStateFromDom(mini) {
    if (!mini) return deriveCartMilestoneState(null);

    const items = Array.from(mini.querySelectorAll(".mini-cart-item")).map((item) => {
      const title = (item.querySelector(".mini-cart-item-title")?.textContent || "").trim();
      const lineTotalText =
        item.querySelector(".min-cart-item-controll-wrapper .mini-cart-item-price")?.textContent ||
        item.querySelector(".mini-cart-item-price:last-child")?.textContent ||
        item.querySelector(".mini-cart-item-price")?.textContent ||
        "";
      const quantity = getFastRRItemQuantity(item);
      return {
        title,
        product_title: title,
        final_line_price: Math.round(parseCurrencyValue(lineTotalText) * 100),
        quantity,
      };
    });

    return deriveCartMilestoneState({ items });
  }

  function getEffectiveCartState(mini = null) {
    if (mini) {
      const domState = deriveMiniCartStateFromDom(mini);
      if (domState.qualifyingSubtotal > 0 || domState.items.length > 0) return domState;
    }

    return STATE.cartState || deriveCartMilestoneState(null);
  }

  function getMilestoneMessaging(state) {
    if (state.giftUnlocked) {
      if (state.freeGiftTrulyFree) {
        return {
          badge: "Gift milestone reached",
          detail: "Shipping, savings, and your Long Jatta sample are now part of this order.",
        };
      }

      return {
        badge: "Gift milestone reached",
        detail: "You have reached the Long Jatta sample milestone.",
      };
    }

    if (state.discountUnlocked) {
      return {
        badge: "10% reward unlocked",
        detail: `Add ${formatCurrencyFromCents(state.remaining)} more to unlock the Long Jatta sample.`,
      };
    }

    if (state.shippingUnlocked) {
      return {
        badge: "Free shipping unlocked",
        detail: `Add ${formatCurrencyFromCents(state.remaining)} more to reach the 10% reward.`,
      };
    }

    return {
      badge: "Reward ladder",
      detail: `Spend ${formatCurrencyFromCents(state.remaining || MILESTONES[0].minSubtotal)} more to unlock free shipping.`,
    };
  }

  function renderRewardBarMarkup(state) {
    const message = getMilestoneMessaging(state);

    return [
      '<div class="nutravel-reward-bar__head">',
      `<p class="nutravel-reward-bar__badge">${message.badge}</p>`,
      `<p class="nutravel-reward-bar__detail">${message.detail}</p>`,
      "</div>",
      '<div class="nutravel-reward-bar__track" aria-hidden="true">',
      `<span class="nutravel-reward-bar__fill" style="width:${state.progress}%;"></span>`,
      "</div>",
      '<div class="nutravel-reward-bar__milestones">',
      `<span class="${state.shippingUnlocked ? "is-active" : ""}">Free shipping at Rs 349</span>`,
      `<span class="${state.discountUnlocked ? "is-active" : ""}">10% reward at Rs 499</span>`,
      `<span class="${state.giftUnlocked ? "is-active" : ""}">Long Jatta sample at Rs 599</span>`,
      "</div>",
      '<div class="nutravel-reward-bar__gift-preview' + (state.giftUnlocked ? ' is-unlocked' : '') + '">',
      `<strong>${FREE_GIFT.title}</strong>`,
      state.giftUnlocked
        ? `<span>${state.freeGiftTrulyFree ? "Complimentary sample is active in cart." : "Milestone unlocked for this order."}</span>`
        : `<span>Cross ${formatCurrencyFromCents(MILESTONES[2].minSubtotal)} in qualifying products to unlock this premium sample.</span>`,
      "</div>",
    ].join("");
  }

  function upsertRewardBar(host, state, className) {
    if (!host) return null;

    let bar = host.querySelector(`.${className}`);
    if (!bar) {
      bar = document.createElement("section");
      bar.className = className;
      host.append(bar);
    }

    bar.innerHTML = renderRewardBarMarkup(state || deriveCartMilestoneState(null));
    return bar;
  }

  async function fetchCartState(force = false) {
    if (!force && STATE.cartPromise) return STATE.cartPromise;

    STATE.cartPromise = fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Unable to refresh cart");
        return response.json();
      })
      .then((cart) => {
        STATE.cartState = deriveCartMilestoneState(cart);
        return STATE.cartState;
      })
      .catch(() => STATE.cartState || deriveCartMilestoneState(null))
      .finally(() => {
        STATE.cartPromise = null;
      });

    return STATE.cartPromise;
  }

  function requestCartRefresh(delay = 180, force = false) {
    if (STATE.cartRefreshTimer) window.clearTimeout(STATE.cartRefreshTimer);

    STATE.cartRefreshTimer = window.setTimeout(() => {
      STATE.cartRefreshTimer = null;
      (force ? fetchCartState(true) : syncFreeGiftEligibility()).then(() => {
        applyCartMilestoneUI();
      });
    }, delay);
  }

  function scheduleFastRRPolish(delay = 80, forceCartRefresh = false) {
    if (STATE.fastRRPolishTimer) window.clearTimeout(STATE.fastRRPolishTimer);

    STATE.fastRRPolishTimer = window.setTimeout(() => {
      STATE.fastRRPolishTimer = null;
      polishFastRRDrawer();
      if (forceCartRefresh) requestCartRefresh(120, true);
    }, delay);
  }

  function applyCartMilestoneUI() {
    const state = STATE.cartState || deriveCartMilestoneState(null);

    document.querySelectorAll(".avisbls-container").forEach((container) => {
      upsertRewardBar(container, state, "nutravel-product-reward-bar");
      container.classList.toggle("nutravel-upsell-has-shipping", state.shippingUnlocked);
      container.classList.toggle("nutravel-upsell-has-discount", state.discountUnlocked);
      container.classList.toggle("nutravel-upsell-has-gift", state.giftUnlocked);
    });

    const mini = document.querySelector("#shiprocket-mini-cart-container");
    if (mini) {
      upsertRewardBar(mini, state, "nutravel-fastrr-reward-bar");
    }
  }

  async function syncFreeGiftEligibility() {
    const state = await fetchCartState();
    const paidGiftDetected = state.freeGiftItem && !state.freeGiftTrulyFree;
    STATE.giftAutomationBlocked = FREE_GIFT.catalogPrice > 0 || paidGiftDetected;
    return state;
  }

  function sanitizeFastRRSummary(summary) {
    if (!summary) return;

    const state = getEffectiveCartState(summary.closest("#shiprocket-mini-cart-container"));
    const liveCart = STATE.cartState?.cart || state.cart || null;

    summary.querySelectorAll("*").forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      const text = (node.textContent || "").replace(/\s+/g, " ").trim();
      if (!text) return;

      if (/milestonereached/i.test(text)) {
        hideElement(node);
        return;
      }

      if (/free shipping/i.test(text) && /-?\s*₹?\s*0(?:\.0+)?\b/i.test(text)) {
        hideElement(node);
        return;
      }

      if (/discount/i.test(text) && /-?\s*₹?\s*0(?:\.0+)?\b/i.test(text)) {
        hideElement(node);
        return;
      }

      if (/^place order$/i.test(text)) {
        node.textContent = "Checkout";
      }
    });

    summary.querySelectorAll(".coupon_container").forEach((node) => {
      const text = (node.textContent || "").replace(/\s+/g, " ").trim();
      if (!text || /milestonereached|free shipping/i.test(text)) {
        hideElement(node);
      }
    });

    const subtotalText = summary.querySelector(".sr-sub-total")?.textContent || "";
    const totalText = summary.querySelector(".total-price")?.textContent || "";
    const subtotalValue = parseCurrencyValue(subtotalText);
    const totalValue = parseCurrencyValue(totalText);
    const fallbackMrpValue = Math.max(subtotalValue, totalValue);
    const fallbackPayableValue = subtotalValue || Math.min(subtotalValue, totalValue) || Math.max(subtotalValue, totalValue);
    const payableValue = subtotalValue || (Number.isFinite(liveCart?.total_price) ? liveCart.total_price / 100 : fallbackPayableValue);
    const mrpValue = Number.isFinite(liveCart?.original_total_price)
      ? liveCart.original_total_price / 100
      : fallbackMrpValue;
    const savingsValue =
      Number.isFinite(liveCart?.original_total_price) && Number.isFinite(liveCart?.total_price)
        ? Math.max(0, (liveCart.original_total_price - liveCart.total_price) / 100)
        : mrpValue > payableValue
          ? mrpValue - payableValue
          : 0;
    const payableText = payableValue ? `₹${payableValue.toFixed(2)}` : subtotalText || totalText || "₹0.00";

    let customSummary = summary.querySelector(".nutravel-fastrr-summary");
    if (!customSummary) {
      customSummary = document.createElement("div");
      customSummary.className = "nutravel-fastrr-summary";
      summary.append(customSummary);
    }

    customSummary.innerHTML = [
      '<div class="nutravel-fastrr-summary__row"><span>Subtotal</span><strong>' +
        formatCurrencyFromCents(state.qualifyingSubtotal) +
        "</strong></div>",
      '<div class="nutravel-fastrr-summary__row"><span>Shipping</span><strong>' +
        (state.shippingUnlocked ? "Unlocked" : `Unlock at ${formatCurrencyFromCents(MILESTONES[0].minSubtotal)}`) +
        "</strong></div>",
      state.discountUnlocked
        ? '<div class="nutravel-fastrr-summary__row"><span>Reward</span><strong>10% unlocked</strong></div>'
        : "",
      savingsValue > 0
        ? '<div class="nutravel-fastrr-summary__row nutravel-fastrr-summary__row--saving"><span>You save</span><strong>₹' +
          savingsValue.toFixed(2) +
          "</strong></div>"
        : "",
      '<div class="nutravel-fastrr-summary__row nutravel-fastrr-summary__row--payable"><span>Pay now</span><strong>' +
        payableText +
        "</strong></div>",
    ].join("");

    summary.querySelectorAll("p:not(.nutravel-fastrr-summary__row), .coupon_container").forEach((node) => {
      if (node !== customSummary && !node.closest(".nutravel-fastrr-summary")) {
        hideElement(node);
      }
    });
  }

  function polishFastRRDrawer() {
    if (!hasFastRRDrawer()) return;

    document.body.classList.add("nutravel-use-fastrr-cart");
    requestCartRefresh(80);

    const mini = document.querySelector("#shiprocket-mini-cart-container");
    if (!mini) return;
    const state = getEffectiveCartState(mini);

    const items = Array.from(mini.querySelectorAll(".mini-cart-item")).filter((item) => {
      const style = window.getComputedStyle(item);
      return style.display !== "none" && style.visibility !== "hidden";
    });
    const itemCount = items.reduce((total, item) => total + getFastRRItemQuantity(item), 0);
    const hasItems = itemCount > 0;

    mini.classList.toggle("nutravel-fastrr-ready", true);
    mini.classList.toggle("nutravel-fastrr-has-items", hasItems);
    mini.classList.toggle("nutravel-fastrr-empty", !hasItems);

    const header = mini.querySelector(".mini-cart-header");
    if (header) {
      const closeButton = header.querySelector("#close-mini-cart, button, [role='button']");
      if (closeButton && !closeButton.hasAttribute("aria-label")) {
        closeButton.setAttribute("aria-label", "Close cart");
      }

      Array.from(header.childNodes)
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .forEach((node) => {
          if (node.textContent) node.textContent = "";
        });

      const titleBlock = header.querySelector(".mini-cart-title-flex");
      const titleText = header.querySelector(".mini-cart-title");
      const countText = header.querySelector(".item_count");
      if (titleBlock && titleText) {
        titleBlock.classList.add("nutravel-fastrr-title-flex");
        if (titleText.textContent !== "Your Cart") titleText.textContent = "Your Cart";
        if (countText) {
          const nextCount = hasItems ? `(${itemCount})` : "";
          if (countText.textContent !== nextCount) countText.textContent = nextCount;
        }
      } else if (!header.querySelector(".nutravel-fastrr-title")) {
        const title = document.createElement("span");
        title.className = "nutravel-fastrr-title";
        title.textContent = hasItems ? `Your Cart (${itemCount})` : "Your Cart";
        header.prepend(title);
      } else {
        const title = header.querySelector(".nutravel-fastrr-title");
        const label = hasItems ? `Your Cart (${itemCount})` : "Your Cart";
        if (title && title.textContent !== label) title.textContent = label;
      }
    }

    mini.querySelectorAll(".mini-cart-empty-cart, .mini-cart-empty-cart-container").forEach((node) => {
      node.classList.toggle("nutravel-hidden", hasItems);
      if (hasItems) {
        node.setAttribute("aria-hidden", "true");
      } else {
        node.removeAttribute("aria-hidden");
      }
    });

    mini.querySelectorAll(".mini-cart-item-title").forEach((title) => {
      const compact = compactTitle(title.textContent || "");
      if (compact) title.textContent = compact;
    });

    mini.querySelectorAll(".mini-cart-item-variant").forEach((variant) => {
      const text = (variant.textContent || "").replace(/\s+/g, " ").trim();
      if (!text || /^default title$/i.test(text)) hideElement(variant);
    });

    mini.querySelectorAll("#sr-buy-now-button, .mini-cart-order-btn").forEach((button) => {
      if (button instanceof HTMLElement) {
        if (button.textContent !== "Checkout") button.textContent = "Checkout";
        button.setAttribute("aria-label", "Proceed to checkout");
      }
    });

    upsertRewardBar(mini, state, "nutravel-fastrr-reward-bar");
    sanitizeFastRRSummary(mini.querySelector(".mini-cart-order-summary"));
  }

  function setupFastRRObserver() {
    if (!hasFastRRDrawer() || document.body.dataset.nutravelFastrrObserverBound) return;

    const mini = document.querySelector("#shiprocket-mini-cart-container");
    if (!mini) return;

    const observer = new MutationObserver(() => {
      scheduleFastRRPolish(90);
    });

    observer.observe(mini, {
      childList: true,
      subtree: true,
    });

    STATE.observers.push(observer);
    document.body.dataset.nutravelFastrrObserverBound = "true";
    polishFastRRDrawer();

    mini.addEventListener(
      "click",
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target.closest(".mini-cart-item-increase, .mini-cart-item-decrease, .mini-cart-item-plus, .mini-cart-item-minus, button")) {
          scheduleFastRRPolish(30, true);
        }
      },
      true
    );
  }

  function sanitizeVisibleTitles() {
    document.querySelectorAll(".card__heading a, .product__title h1, .product__title h2").forEach((node) => {
      const original = node.dataset.originalTitle || node.textContent.trim();
      if (!node.dataset.originalTitle) node.dataset.originalTitle = original;
      const compact = compactTitle(original);
      if (compact) node.textContent = compact;
    });
  }

  function createButton(label, href, secondary) {
    const link = document.createElement("a");
    link.href = href;
    link.className = secondary ? "button button--secondary" : "button button--primary";
    link.textContent = label;
    return link;
  }

  function createSupportLink(label, href, className) {
    const link = document.createElement("a");
    link.href = href;
    link.className = className;
    link.textContent = label;
    if (/^https?:\/\//.test(href)) {
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    }
    return link;
  }

  function formatDateTime(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  }

  function getAssetUrl(filename) {
    return `${ASSET_BASE}${filename}`;
  }

  function getActiveHeroTarget() {
    return (
      document.querySelector('.shopify-section[id*="slideshow"] .slideshow__slide.is-active .slideshow__text') ||
      document.querySelector('.shopify-section[id*="slideshow"] .slideshow__slide[aria-hidden="false"] .slideshow__text') ||
      document.querySelector('.shopify-section[id*="slideshow"] .slideshow__text')
    );
  }

  function mountHeroScene() {
    if (!isHomepage()) return;

    const heroTarget = getActiveHeroTarget();
    if (!heroTarget || heroTarget.querySelector(".nutravel-hero-scene")) return;

    const scene = document.createElement("div");
    scene.className = "nutravel-hero-scene";
    scene.innerHTML = [
      '<div class="nutravel-hero-scene__content">',
      '<span class="nutravel-hero-scene__eyebrow">Shop Nutravel</span>',
      '<h1 class="nutravel-hero-scene__title">Ayurvedic essentials for everyday wellness.</h1>',
      '<p class="nutravel-hero-scene__copy">Clearer shopping across capsules, syrups, powders, and oils.</p>',
      '<div class="nutravel-hero-scene__actions"></div>',
      "</div>",
    ].join("");

    const actions = scene.querySelector(".nutravel-hero-scene__actions");
    actions.append(createButton("Shop Bestsellers", "/collections/shop", false));

    heroTarget.append(scene);
  }

  function cleanupDuplicateHeroScenes() {
    const scenes = Array.from(document.querySelectorAll(".nutravel-hero-scene"));
    if (scenes.length <= 1) return;

    scenes.forEach((scene) => {
      const slide = scene.closest(".slideshow__slide");
      if (slide && slide.getAttribute("aria-hidden") === "true") {
        scene.remove();
      }
    });
  }

  function classifyHeroSlides() {
    if (!isHomepage()) return;

    document.querySelectorAll('.shopify-section[id*="slideshow"] .slideshow__slide').forEach((slide) => {
      slide.classList.remove("nutravel-slide--left", "nutravel-slide--center");
      const align = "center";
      slide.classList.add(`nutravel-slide--${align}`);
      slide.dataset.nutravelAlign = align;
    });
  }

  function mountSalesAssist() {
    if (document.querySelector(".nutravel-support-fab")) return;

    const fab = document.createElement("a");
    fab.className = "nutravel-support-fab";
    fab.href = WHATSAPP_URL;
    fab.target = "_blank";
    fab.rel = "noopener noreferrer";
    fab.setAttribute("aria-label", "Chat with Nutravel on WhatsApp");
    fab.innerHTML = '<span class="nutravel-support-fab__label">WhatsApp</span>';
    document.body.append(fab);
  }

  function mountCategoryRail() {
    if (!isHomepage()) return;

    const slideshowSection = document.querySelector('.shopify-section[id*="slideshow"]');
    if (!slideshowSection || document.querySelector(".nutravel-category-rail")) return;

    const rail = document.createElement("section");
    rail.className = "nutravel-category-rail";
    rail.innerHTML = '<div class="nutravel-category-rail__inner"></div>';

    const inner = rail.querySelector(".nutravel-category-rail__inner");

    CATEGORY_LINKS.forEach((item) => {
      const link = document.createElement("a");
      link.className = "nutravel-category-rail__item";
      link.href = item.href;
      link.innerHTML = `<span>${item.label}</span>`;
      inner.append(link);
    });

    slideshowSection.insertAdjacentElement("afterend", rail);
  }

  function mountHomepageTrustStrip() {
    if (!isHomepage()) return;

    const featuredCollection = document.querySelector('.shopify-section[id*="featured_collection"]');
    if (!featuredCollection || document.querySelector(".nutravel-trust-strip")) return;

    const strip = document.createElement("section");
    strip.className = "nutravel-trust-strip";
    strip.innerHTML = '<div class="nutravel-trust-strip__inner"></div>';

    const inner = strip.querySelector(".nutravel-trust-strip__inner");
    TRUST_POINTS.forEach((item) => {
      const card = document.createElement("article");
      card.className = "nutravel-trust-strip__item";
      card.innerHTML = `<h3>${item.title}</h3><p>${item.body}</p>`;
      inner.append(card);
    });

    featuredCollection.insertAdjacentElement("afterend", strip);
  }

  function mountHomepageManufacturingSpotlight() {
    if (!isHomepage()) return;

    const secondaryTarget =
      document.querySelector('.shopify-section[id*="multicolumn"]') ||
      document.querySelector(".footer");
    if (!secondaryTarget || document.querySelector(".nutravel-manufacturing-spotlight")) return;

    const spotlight = document.createElement("section");
    spotlight.className = "nutravel-manufacturing-spotlight nutravel-depth-panel";
    spotlight.innerHTML = [
      '<div class="nutravel-manufacturing-spotlight__media">',
      `<img src="${getAssetUrl("nutravel-factory-mixing.jpg")}" alt="Nutravel manufacturing team working with stainless steel formulation vessels" loading="lazy">`,
      "</div>",
      '<div class="nutravel-manufacturing-spotlight__content">',
      '<p class="nutravel-manufacturing-spotlight__eyebrow">Inside the plant</p>',
      "<h2>Manufacturing support for partner enquiries.</h2>",
      "<p>Private label and third-party manufacturing remain available through dedicated Nutravel production and packing capabilities.</p>",
      '<div class="nutravel-manufacturing-spotlight__points">',
      "<span>Dedicated process zones</span>",
      "<span>Batch-oriented workflow</span>",
      "<span>Partner-ready capabilities</span>",
      "</div>",
      "</div>",
    ].join("");

    spotlight.addEventListener("click", (event) => {
      if (event.target.closest("a, button")) return;
      window.location.href = B2B_PATH;
    });

    const ctaWrap = document.createElement("div");
    ctaWrap.className = "nutravel-manufacturing-spotlight__actions";
    ctaWrap.append(createButton("View manufacturing", B2B_PATH, false));
    spotlight.querySelector(".nutravel-manufacturing-spotlight__content").append(ctaWrap);

    secondaryTarget.insertAdjacentElement("beforebegin", spotlight);
  }

  function hideNoisySections() {
    if (!isHomepage()) return;

    document.querySelectorAll('a[href^="#rfvideo"]').forEach((anchor) => {
      const section = anchor.closest(".shopify-section, section, .page-width");
      if (!section || section.dataset.nutravelHiddenVideoStrip) return;
      if (section.querySelectorAll('a[href^="#rfvideo"]').length >= 3) {
        section.dataset.nutravelHiddenVideoStrip = "true";
        hideElement(section);
      }
    });

    document.querySelectorAll(".shopify-section").forEach((section) => {
      if (section.querySelector("#insta-feed")) hideElement(section);
      if (section.textContent.includes("Now Available On: Flipkart")) hideElement(section);
    });
  }

  function enhanceCollectionHero() {
    if (!isCollection()) return;

    const titleWrap = document.querySelector(".collection-hero__text-wrapper");
    if (!titleWrap) return;

    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    const handle = match ? match[1] : null;
    const introCopy = handle ? COLLECTION_INTROS[handle] : null;

    if (introCopy && !titleWrap.querySelector(".nutravel-collection-intro")) {
      const intro = document.createElement("p");
      intro.className = "nutravel-collection-intro";
      intro.textContent = introCopy;
      titleWrap.append(intro);
    }

    const hero = titleWrap.closest(".collection-hero");
    if (hero) hero.classList.add("nutravel-depth-panel");
  }

  function enhanceProductCards() {
    document.querySelectorAll(".card-wrapper").forEach((node) => {
      node.classList.add("nutravel-reveal");
    });
  }

  function stabiliseHomepageScroll() {
    if (!isHomepage()) return;

    document
      .querySelectorAll(
        '.shopify-section[id*="featured_collection"] slider-component, .shopify-section[id*="featured_collection"] .slider, .shopify-section[id*="multicolumn"] slider-component, .shopify-section[id*="multicolumn"] .slider'
      )
      .forEach((node) => {
        if (node.dataset.nutravelScrollSafe) return;

        node.dataset.nutravelScrollSafe = "true";
        node.classList.add("nutravel-scroll-safe-rail");
      });
  }

  function reconcileUpsellExperience() {
    if (!isProduct()) return;

    document.querySelectorAll(".yn-dc-promo-table-container, .yn-tw-r.yn-dc-promo-table-container").forEach((node) => {
      if ((node.textContent || "").trim()) return;
      hideElement(node);
    });

    document.querySelectorAll(".avisbls-container").forEach((container) => {
      if (container.dataset.nutravelBound) return;

      container.classList.add("nutravel-upsell-shell");
      if (!container.querySelector(".nutravel-upsell-intro")) {
        const intro = document.createElement("div");
        intro.className = "nutravel-upsell-intro";
        intro.innerHTML = [
          '<p class="nutravel-upsell-intro__eyebrow">Best value</p>',
          "<h3>Pick the option that gives you the strongest value.</h3>",
          "<p>Build toward shipping, savings, and the Long Jatta sample.</p>",
        ].join("");
        container.prepend(intro);
      }

      const quantityInput =
        document.querySelector('input.avisbls-quantity-form[name="quantity"]') ||
        document.querySelector('input.quantity__input[name="quantity"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      const offerNodes = Array.from(container.querySelectorAll(".avisbls-offer"));
      let isSyncing = false;

      const getOfferQuantity = (node) => {
        const offerText = (node?.textContent || "").replace(/\s+/g, " ").trim();
        const quantityMatch = offerText.match(/(\d+)\s*Unit/i);
        return quantityMatch ? Number.parseInt(quantityMatch[1], 10) : 1;
      };

      const getQuantityValue = () => {
        const parsed = Number.parseInt(quantityInput?.value || "1", 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
      };

      const getTargetOfferForQuantity = (quantity) => {
        const safeQty = Math.max(1, Number.parseInt(quantity, 10) || 1);
        if (!offerNodes.length) return null;

        if (safeQty >= 3) {
          return offerNodes.find((node) => getOfferQuantity(node) >= 3) || offerNodes[offerNodes.length - 1];
        }

        if (safeQty === 2) {
          return offerNodes.find((node) => getOfferQuantity(node) === 2) || offerNodes[1] || offerNodes[0];
        }

        return offerNodes.find((node) => getOfferQuantity(node) === 1) || offerNodes[0];
      };

      const ensureOfferSelection = (targetOffer) => {
        if (!targetOffer) return;
        const radio = targetOffer.querySelector(".avisbls-radio");
        if (radio && !radio.checked) {
          isSyncing = true;
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
          targetOffer.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
          window.setTimeout(() => {
            isSyncing = false;
          }, 40);
        }
      };

      const syncSelectedOffer = (source = "offer") => {
        if (isSyncing) return;

        const checkedInput = container.querySelector(".avisbls-radio:checked");
        let selectedOffer =
          checkedInput?.closest(".avisbls-offer") ||
          offerNodes.find((node) => node.classList.contains("active") || node.classList.contains("selected")) ||
          offerNodes[0];

        const currentQuantity = getQuantityValue();
        if (source === "quantity") {
          const quantityOffer = getTargetOfferForQuantity(currentQuantity);
          if (quantityOffer) {
            selectedOffer = quantityOffer;
            ensureOfferSelection(quantityOffer);
          }
        }

        offerNodes.forEach((node) => {
          node.classList.toggle("nutravel-upsell-offer--active", node === selectedOffer);
        });

        const offerText = (selectedOffer?.textContent || "").replace(/\s+/g, " ").trim();
        const quantityMatch = offerText.match(/(\d+)\s*Unit/i);

        if (source === "offer" && quantityInput && quantityMatch) {
          quantityInput.value = quantityMatch[1];
          quantityInput.setAttribute("value", quantityMatch[1]);
        }

        upsertRewardBar(container, STATE.cartState || deriveCartMilestoneState(null), "nutravel-product-reward-bar");
      };

      container.addEventListener("change", () => syncSelectedOffer("offer"));
      container.addEventListener("click", () => window.setTimeout(() => syncSelectedOffer("offer"), 40));
      if (quantityInput) {
        quantityInput.addEventListener("input", () => syncSelectedOffer("quantity"));
        quantityInput.addEventListener("change", () => syncSelectedOffer("quantity"));
      }
      container.querySelectorAll(".avisbls-offer").forEach((offer) => {
        const text = (offer.textContent || "").replace(/\s+/g, " ").trim();
        if (/most popular/i.test(text)) offer.classList.add("nutravel-upsell-offer--popular");
      });
      syncSelectedOffer("offer");
      container.dataset.nutravelBound = "true";
    });
  }

  function enhanceProductPage() {
    if (!isProduct()) return;

    const titleNode = document.querySelector(".product__title h1");
    const priceNode = document.querySelector(".price__container");
    const buttonWrap = document.querySelector(".product-form__buttons");
    const infoContainer = document.querySelector(".product__info-container");
    const productShell = document.querySelector(".product.product--small");

    if (productShell) productShell.classList.add("nutravel-product-shell");
    if (infoContainer) infoContainer.classList.add("nutravel-product-stack");

    if (titleNode && priceNode && !document.querySelector(".nutravel-product-summary")) {
      const copy = getProductCopy(titleNode.dataset.originalTitle || titleNode.textContent.trim());
      const summary = document.createElement("section");
      summary.className = "nutravel-product-summary nutravel-depth-panel";
      summary.innerHTML = [
        `<p class="nutravel-product-summary__eyebrow">${copy.eyebrow}</p>`,
        `<p class="nutravel-product-summary__text">${copy.summary}</p>`,
      ].join("");
      priceNode.insertAdjacentElement("afterend", summary);
    }

    if (buttonWrap && !buttonWrap.querySelector(".nutravel-product-trust")) {
      const trust = document.createElement("div");
      trust.className = "nutravel-product-trust";
      trust.innerHTML = [
        "<span>Quality-assured Ayurveda</span>",
        "<span>Fast support on WhatsApp</span>",
        "<span>Designed for daily rituals</span>",
      ].join("");
      buttonWrap.append(trust);
    }
  }

  function renderTrackingResult(resultNode, data) {
    const orderRef = data?.order?.orderNumber || data?.order_number || data?.order?.name || "";
    const placedAt = data?.order?.placedAt || data?.placed_at || "";
    const shipment = data?.shipment || {};
    const status = shipment.status || data?.status || "Tracking in progress";
    const courier = shipment.courier || data?.courier || "iCarry";
    const awb = shipment.awb || data?.awb || "";
    const expected = shipment.expectedDelivery || data?.expected_delivery || "";
    const lastUpdated = shipment.lastUpdated || data?.last_updated || "";
    const events = shipment.events || data?.events || [];

    const timeline = events.length
      ? `<div class="nutravel-track-timeline">${events
          .slice(0, 4)
          .map(
            (event) => `<article class="nutravel-track-timeline__item">
                <strong>${event.notes || event.status || "Shipment update"}</strong>
                <span>${event.location || courier}</span>
                <time>${formatDateTime(event.datetime || event.date || event.timestamp)}</time>
              </article>`
          )
          .join("")}</div>`
      : `<p class="nutravel-track-result__hint">We will show shipment scans here as soon as the courier updates them.</p>`;

    resultNode.innerHTML = [
      '<div class="nutravel-track-result__panel">',
      `<p class="nutravel-track-result__eyebrow">Order ${orderRef || ""}</p>`,
      `<h3>${status}</h3>`,
      '<div class="nutravel-track-result__meta">',
      orderRef ? `<span>Order: ${orderRef}</span>` : "",
      awb ? `<span>AWB: ${awb}</span>` : "",
      courier ? `<span>Courier: ${courier}</span>` : "",
      expected ? `<span>Expected: ${formatDateTime(expected)}</span>` : "",
      placedAt ? `<span>Placed: ${formatDateTime(placedAt)}</span>` : "",
      lastUpdated ? `<span>Updated: ${formatDateTime(lastUpdated)}</span>` : "",
      "</div>",
      timeline,
      "</div>",
    ].join("");
  }

  function renderTrackingMessage(resultNode, title, body, tone) {
    const orderValue = resultNode?.dataset?.lastOrderNumber || "";
    const contactValue = resultNode?.dataset?.lastContactValue || "";

    resultNode.innerHTML = [
      `<div class="nutravel-track-result__panel nutravel-track-result__panel--${tone || "info"}">`,
      `<h3>${title}</h3>`,
      `<p>${body}</p>`,
      buildTrackingSupportMarkup(orderValue, contactValue),
      "</div>",
    ].join("");
  }

  function classifyLegacyTrackingState(widgetRoot) {
    if (!widgetRoot) return;

    const messageNode = widgetRoot.querySelector(".go2730653169");
    const text = (messageNode?.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();

    widgetRoot.classList.remove(
      "nutravel-track-widget--has-message",
      "nutravel-track-widget--not-found",
      "nutravel-track-widget--delayed",
      "nutravel-track-widget--success"
    );

    if (!text) return;

    widgetRoot.classList.add("nutravel-track-widget--has-message");

    if (/not found|could not|unable to/i.test(text)) {
      widgetRoot.classList.add("nutravel-track-widget--not-found");
      return;
    }

    if (/delay|exception|failed|hold|pending/i.test(text)) {
      widgetRoot.classList.add("nutravel-track-widget--delayed");
      return;
    }

    widgetRoot.classList.add("nutravel-track-widget--success");
  }

  function enhanceLegacyTrackingFeedback(widgetRoot) {
    if (!widgetRoot) return;

    classifyLegacyTrackingState(widgetRoot);

    const messageNode = widgetRoot.querySelector(".go2730653169");
    if (!messageNode) return;

    const text = (messageNode.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    const orderNumber = widgetRoot.dataset.lastOrderNumber || "";
    const phoneNumber = widgetRoot.dataset.lastPhoneNumber || "";

    const existingHint = widgetRoot.querySelector(".nutravel-track-widget__hint");
    if (existingHint) existingHint.remove();

    if (/not found|could not|unable to/i.test(text)) {
      messageNode.textContent = "We could not find a shipment yet";

      const hint = document.createElement("div");
      hint.className = "nutravel-track-widget__hint";
      hint.innerHTML = [
        "<p>If you placed your order recently, it may still be confirmed in Shopify and waiting for dispatch. Tracking usually appears after fulfillment is created.</p>",
        `<p><a href="https://wa.me/${SUPPORT_PHONE_DIGITS}?text=${encodeURIComponent(
          `Hello Nutravel, please help me with order ${orderNumber || ""} for ${phoneNumber || ""}. It is not visible on the tracking page yet.`
        )}" target="_blank" rel="noopener noreferrer">Get help on WhatsApp</a></p>`,
      ].join("");

      const alert = widgetRoot.querySelector(".go1310524542");
      if (alert) alert.insertAdjacentElement("afterend", hint);
    }
  }

  function buildTrackingTrustMarkup() {
    return TRACKING_TRUST_POINTS.map(
      (item) => `<article class="nutravel-track-page__trust-card">
        <p class="nutravel-track-page__trust-title">${item.title}</p>
        <p>${item.body}</p>
      </article>`
    ).join("");
  }

  function buildTrackingStagesMarkup() {
    return TRACKING_STAGES.map(
      (item) => `<article class="nutravel-track-stage">
        <span class="nutravel-track-stage__step">${item.step}</span>
        <div class="nutravel-track-stage__body">
          <h3>${item.title}</h3>
          <p>${item.body}</p>
        </div>
      </article>`
    ).join("");
  }

  function buildTrackingSupportMarkup(orderValue, contactValue) {
    const message = encodeURIComponent(
      `Hello Nutravel, please help me verify order ${orderValue || ""} for ${contactValue || ""}.`
    );

    return `<div class="nutravel-track-result__support"><a href="https://wa.me/${SUPPORT_PHONE_DIGITS}?text=${message}" target="_blank" rel="noopener noreferrer">WhatsApp us</a><a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a></div>`;
  }

  function normaliseOrderNumber(orderValue) {
    const clean = (orderValue || "").trim();
    if (!clean) return [];

    const withoutHash = clean.replace(/^#/, "");
    return Array.from(new Set([`#${withoutHash}`, withoutHash].filter(Boolean)));
  }

  function normaliseContactValues(contactValue) {
    const raw = (contactValue || "").trim();
    if (!raw) return [];

    if (raw.includes("@")) {
      return [{ email: raw.toLowerCase(), phone: "" }];
    }

    return [];
  }

  function extractPostshipLookup(raw) {
    if (!raw || typeof raw !== "object") return null;

    const source = raw.order || raw.data || raw;
    const shipments = Array.isArray(source.shipments) ? source.shipments : Array.isArray(raw.shipments) ? raw.shipments : [];
    const shipment = shipments[0] || source.shipment || raw.shipment || {};
    const carrier = shipment?.carrier || {};
    const checkpoints = Array.isArray(shipment?.checkpoints)
      ? shipment.checkpoints
      : Array.isArray(shipment?.events)
        ? shipment.events
        : Array.isArray(raw?.events)
          ? raw.events
          : [];

    return {
      order_number: source.orderNumber || source.order_number || source.name || raw.orderNumber || "",
      placed_at: source.createdAt || source.placedAt || source.processedAt || raw.placed_at || "",
      status:
        shipment?.currentStatus ||
        shipment?.status ||
        source.preShipmentStatus ||
        raw.status ||
        "Tracking in progress",
      courier: carrier.name || carrier.title || shipment?.courier || raw.courier || "Nutravel logistics",
      awb: carrier.nativeTrackingNumber || shipment?.trackingNumber || shipment?.awb || raw.awb || "",
      expected_delivery:
        shipment?.estimatedDeliveryDate ||
        shipment?.expectedDelivery ||
        raw.expected_delivery ||
        "",
      last_updated:
        shipment?.updatedAt ||
        shipment?.lastUpdated ||
        shipment?.latestCheckpoint?.time ||
        raw.last_updated ||
        "",
      events: checkpoints.map((event) => ({
        notes: event?.description || event?.status || event?.notes || "Shipment update",
        status: event?.status || event?.description || "Shipment update",
        location: event?.location || event?.city || carrier.name || "",
        datetime: event?.createdAt || event?.date || event?.datetime || event?.timestamp || "",
      })),
    };
  }

  async function fetchPostshipTracking(orderValue, contactValue) {
    const orderCandidates = normaliseOrderNumber(orderValue);
    const contactCandidates = normaliseContactValues(contactValue);

    if (!orderCandidates.length || !contactCandidates.length) {
      throw new Error("Enter a valid order number and the email or mobile used at checkout.");
    }

    for (const orderNumber of orderCandidates) {
      for (const candidate of contactCandidates) {
        const response = await fetch(POSTSHIP_STATUS_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            shop: TRACKING_SHOP,
            orderNumber,
            email: candidate.email || "",
            phone: candidate.phone || "",
            trackingNumber: "",
          }),
        });

        const text = await response.text();
        let data = null;

        try {
          data = text ? JSON.parse(text) : null;
        } catch (error) {
          data = null;
        }

        if (response.ok && data && typeof data === "object") {
          return extractPostshipLookup(data) || data;
        }

        if (!response.ok) {
          throw new Error("We could not reach the tracking service right now.");
        }
      }
    }

    throw new Error("We could not find a live shipment yet.");
  }

  async function submitTrackingLookup(form, resultNode) {
    const modeValue = form.querySelector('[name="tracking_mode"]:checked')?.value || "order";
    const orderValue = (form.querySelector('[name="order_number"]')?.value || "").trim();
    const contactValue = (form.querySelector('[name="contact"]')?.value || "").trim();
    const trackingNumberValue = (form.querySelector('[name="tracking_number"]')?.value || "").trim();

    resultNode.dataset.lastOrderNumber = orderValue;
    resultNode.dataset.lastContactValue = contactValue;

    if (modeValue === "tracking_number") {
      if (!trackingNumberValue) {
        renderTrackingMessage(
          resultNode,
          "Enter a tracking number",
          "Please enter the AWB or tracking number from your shipping confirmation.",
          "warn"
        );
        return;
      }

      window.location.href = `${TRACKING_NUMBER_URL}${encodeURIComponent(trackingNumberValue)}`;
      return;
    }

    if (!orderValue || !contactValue) {
      renderTrackingMessage(
        resultNode,
        "Enter valid details",
        "Please enter your order number and the same checkout email used when the order was placed.",
        "warn"
      );
      return;
    }

    resultNode.innerHTML = '<div class="nutravel-track-result__panel nutravel-track-result__panel--loading"><h3>Checking your order</h3><p>Please wait while we fetch the latest shipment updates.</p></div>';

    try {
      const data = TRACKING_PROXY_URL
        ? await (async () => {
            const response = await fetch(TRACKING_PROXY_URL, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ orderNumber: orderValue, contact: contactValue }),
            });
            const json = await response.json();

            if (!response.ok || json?.success === false) {
              throw new Error(json?.message || json?.error || "We could not find that order right now.");
            }

            return json;
          })()
        : await fetchPostshipTracking(orderValue, contactValue);

      renderTrackingResult(resultNode, data);
    } catch (error) {
      renderTrackingMessage(
        resultNode,
        "We could not find a live shipment yet",
        error?.message ||
          "If your order was placed recently, shipment tracking may appear after dispatch. Please check your checkout email, or use the tracking ID from your shipping confirmation.",
        "warn"
      );
    }
  }

  function setTrackingFormMode(form, resultNode, modeValue) {
    if (!form) return;

    const orderFields = form.querySelector(".nutravel-track-form__group--order");
    const trackingFields = form.querySelector(".nutravel-track-form__group--tracking");
    const button = form.querySelector('button[type="submit"]');

    form.dataset.mode = modeValue;

    if (orderFields) orderFields.hidden = modeValue !== "order";
    if (trackingFields) trackingFields.hidden = modeValue !== "tracking_number";

    if (button) {
      button.textContent = modeValue === "tracking_number" ? "Continue to live tracker" : "Track order";
    }

    if (resultNode) {
      if (modeValue === "tracking_number") {
        renderTrackingMessage(
          resultNode,
          "Track with your shipment ID",
          "Use the AWB or tracking number from your shipping email or WhatsApp update to open the live courier tracker.",
          "info"
        );
      } else {
        renderTrackingMessage(
          resultNode,
          "Track with order number",
          "Use your order number and the same checkout email used when the order was placed.",
          "info"
        );
      }
    }
  }

  function styleLegacyTrackWidget(widgetRoot, pageWrap) {
    if (!widgetRoot) return;

    widgetRoot.classList.add("nutravel-track-widget");
    classifyLegacyTrackingState(widgetRoot);

    widgetRoot.querySelectorAll("h1, h2").forEach((node) => hideElement(node));
    widgetRoot.querySelectorAll("div").forEach((node) => {
      if (!node.children.length && !(node.textContent || "").trim()) hideElement(node);
    });

    const inputs = widgetRoot.querySelectorAll("input");
    if (inputs[0]) {
      inputs[0].setAttribute("placeholder", "Order number");
      inputs[0].setAttribute("aria-label", "Order number");
    }
    if (inputs[1]) {
      inputs[1].setAttribute("type", "tel");
      inputs[1].setAttribute("placeholder", "Phone number");
      inputs[1].setAttribute("inputmode", "numeric");
      inputs[1].setAttribute("aria-label", "Phone number");
    }

    const trackButton = widgetRoot.querySelector(".go1211813134");
    if (trackButton && !trackButton.dataset.nutravelBound) {
      const captureLookup = () => {
        widgetRoot.dataset.lastOrderNumber = (inputs[0]?.value || "").trim();
        widgetRoot.dataset.lastPhoneNumber = (inputs[1]?.value || "").replace(/\D+/g, "");
        window.setTimeout(() => enhanceLegacyTrackingFeedback(widgetRoot), 900);
        window.setTimeout(() => enhanceLegacyTrackingFeedback(widgetRoot), 1800);
      };

      trackButton.addEventListener("click", captureLookup);
      inputs.forEach((input) => {
        input.addEventListener("keydown", (event) => {
          if (event.key === "Enter") captureLookup();
        });
      });
      trackButton.dataset.nutravelBound = "true";
    }

    widgetRoot.querySelectorAll("input").forEach((input) => {
      const placeholder = input.getAttribute("placeholder") || "";
      if (/tracking number/i.test(placeholder)) {
        const row = input.closest("div");
        if (row) {
          row.style.setProperty("display", "none", "important");
          row.setAttribute("aria-hidden", "true");
        }
      }
    });
    pageWrap.querySelectorAll(".nutravel-track-page__support").forEach((node) => node.remove());
    enhanceLegacyTrackingFeedback(widgetRoot);
  }

  function mountTrackOrderExperience() {
    if (!isTrackOrder()) return;

    const pageWrap = document.querySelector("#MainContent .page-width.page-width--narrow");
    if (!pageWrap) return;

    pageWrap.classList.add("nutravel-track-page");

    const title = pageWrap.querySelector(".main-page-title");
    if (title) hideElement(title);

    const existingRte = pageWrap.querySelector(".rte");

    if (!pageWrap.querySelector(".nutravel-track-page__hero")) {
      const hero = document.createElement("section");
      hero.className = "nutravel-track-page__hero nutravel-depth-panel";
      hero.innerHTML = [
        '<div class="nutravel-track-page__hero-glow" aria-hidden="true"></div>',
        '<div class="nutravel-track-page__hero-copy">',
        '<p class="nutravel-track-page__eyebrow">Track your Nutravel order</p>',
        "<h1>Beautifully simple order tracking.</h1>",
        "<p>Use your order number with the checkout email, or jump straight to live courier tracking with your AWB or tracking ID.</p>",
        "</div>",
        '<div class="nutravel-track-page__lookup-shell">',
        '<div class="nutravel-track-page__lookup-head">',
        '<p class="nutravel-track-page__lookup-kicker">Order lookup</p>',
        "<h2>Find your latest delivery update</h2>",
        "</div>",
        '<div class="nutravel-track-page__lookup-slot"></div>',
        "</div>",
        `<div class="nutravel-track-page__trust-grid">${buildTrackingTrustMarkup()}</div>`,
      ].join("");
      pageWrap.prepend(hero);
    }

    if (!pageWrap.querySelector(".nutravel-track-page__journey")) {
      const journey = document.createElement("section");
      journey.className = "nutravel-track-page__journey nutravel-depth-panel";
      journey.innerHTML = [
        '<div class="nutravel-track-page__section-head">',
        '<p class="nutravel-track-page__section-eyebrow">Tracking journey</p>',
        "<h2>What each update usually means</h2>",
        "<p>A quick guide to the stages you may see between confirmation, dispatch, transit, and doorstep delivery.</p>",
        "</div>",
        `<div class="nutravel-track-page__stages">${buildTrackingStagesMarkup()}</div>`,
      ].join("");
      pageWrap.append(journey);
    }

    if (!pageWrap.querySelector(".nutravel-track-page__help")) {
      const help = document.createElement("section");
      help.className = "nutravel-track-page__help nutravel-depth-panel";
      help.innerHTML = [
        '<div class="nutravel-track-page__section-head nutravel-track-page__section-head--left">',
        '<p class="nutravel-track-page__section-eyebrow">Need help?</p>',
        "<h2>Support for delayed or missing orders</h2>",
        "<p>If your order has not moved yet or the lookup does not find it immediately, our team can guide you faster on WhatsApp and email.</p>",
        "</div>",
        '<div class="nutravel-track-page__help-grid">',
        '<article class="nutravel-track-help-card">',
        "<h3>WhatsApp support</h3>",
        "<p>Get direct order help with the Nutravel team when you need a quick update.</p>",
        `<a class="button button--primary" href="${WHATSAPP_URL}" target="_blank" rel="noopener noreferrer">Chat on WhatsApp</a>`,
        "</article>",
        '<article class="nutravel-track-help-card nutravel-track-help-card--soft">',
        "<h3>Email support</h3>",
        "<p>Prefer email? Share your order details and we will help verify the latest tracking status.</p>",
        `<a class="button button--secondary" href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>`,
        "</article>",
        "</div>",
      ].join("");
      pageWrap.append(help);
    }

    const lookupSlot = pageWrap.querySelector(".nutravel-track-page__lookup-slot");
    if (!lookupSlot) return;

    if (existingRte) {
      existingRte.classList.add("nutravel-track-page__legacy");
      hideElement(existingRte);
    }

    if (!lookupSlot.querySelector(".nutravel-track-shell")) {
      const shell = document.createElement("section");
      shell.className = "nutravel-track-shell nutravel-depth-panel";
      shell.innerHTML = [
        '<form class="nutravel-track-form">',
        '<div class="nutravel-track-form__modes">',
        '<label class="nutravel-track-form__mode"><input type="radio" name="tracking_mode" value="order" checked><span>Order number</span></label>',
        '<label class="nutravel-track-form__mode"><input type="radio" name="tracking_mode" value="tracking_number"><span>Tracking ID / AWB</span></label>',
        "</div>",
        '<div class="nutravel-track-form__group nutravel-track-form__group--order">',
        '<label><span>Order number</span><input name="order_number" type="text" placeholder="Enter your order number" autocomplete="off"></label>',
        '<label><span>Checkout email</span><input name="contact" type="email" placeholder="Use the same email entered at checkout" autocomplete="email"></label>',
        '<p class="nutravel-track-form__note">Order lookup works best with the checkout email. Shipment scans usually appear after dispatch is created.</p>',
        "</div>",
        '<div class="nutravel-track-form__group nutravel-track-form__group--tracking" hidden>',
        '<label><span>Tracking number / AWB</span><input name="tracking_number" type="text" placeholder="Enter the tracking ID from your shipping message" autocomplete="off"></label>',
        '<p class="nutravel-track-form__note">This opens the live courier tracker using the shipment ID from your dispatch email or WhatsApp update.</p>',
        "</div>",
        '<button class="button button--primary" type="submit">Track order</button>',
        "</form>",
        '<div class="nutravel-track-result"></div>',
      ].join("");
      lookupSlot.append(shell);

      const form = shell.querySelector(".nutravel-track-form");
      const result = shell.querySelector(".nutravel-track-result");
      setTrackingFormMode(form, result, "order");
      form.querySelectorAll('[name="tracking_mode"]').forEach((input) => {
        input.addEventListener("change", () => {
          setTrackingFormMode(form, result, input.value);
        });
      });
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        submitTrackingLookup(form, result);
      });
    }

    const legacyWidget = pageWrap.querySelector("#postship-root");
    if (legacyWidget) {
      hideElement(legacyWidget);
    }
  }

  function enhanceB2BPage() {
    if (!isB2B()) return;

    const main = document.querySelector("#MainContent");
    if (!main || main.querySelector(".nutravel-b2b-intro")) return;

    const intro = document.createElement("section");
    intro.className = "nutravel-b2b-intro nutravel-depth-panel";
    intro.innerHTML = [
      '<p class="nutravel-b2b-intro__eyebrow">Manufacturing and distribution</p>',
      "<h1>Ayurvedic manufacturing, presented with greater polish and trust.</h1>",
      "<p>A more composed B2B entry point for private label, third-party manufacturing, and partner conversations without competing with the shopping journey.</p>",
    ].join("");

    main.insertAdjacentElement("afterbegin", intro);

    const gallery = document.createElement("section");
    gallery.className = "nutravel-factory-gallery";
    gallery.innerHTML = [
      '<div class="nutravel-factory-gallery__intro">',
      '<p class="nutravel-factory-gallery__eyebrow">Facility walkthrough</p>',
      "<h2>Real manufacturing spaces across formulation, filling, inspection, and packing.</h2>",
      "<p>These photographs show the operational side of Nutravel, from batch preparation and monitored process areas to packaging and workspace discipline. The aim is simple: give partners a clearer, more credible view of the environment behind production.</p>",
      "</div>",
      '<div class="nutravel-factory-gallery__grid"></div>',
      '<div class="nutravel-factory-gallery__footer">',
      "<p>From process vessels and decoction areas to filling lines, clean rooms, inspection stations, and support offices, the facility is organised to support dependable Ayurvedic manufacturing conversations.</p>",
      "</div>",
    ].join("");

    const grid = gallery.querySelector(".nutravel-factory-gallery__grid");
    FACTORY_GALLERY.forEach((item) => {
      const card = document.createElement("article");
      card.className = "nutravel-factory-card nutravel-depth-panel";
      card.innerHTML = [
        '<div class="nutravel-factory-card__image-wrap">',
        `<img class="nutravel-factory-card__image" src="${getAssetUrl(item.file)}" alt="${item.title}" loading="lazy">`,
        "</div>",
        '<div class="nutravel-factory-card__body">',
        `<h3>${item.title}</h3>`,
        `<p>${item.body}</p>`,
        "</div>",
      ].join("");
      grid.append(card);
    });

    intro.insertAdjacentElement("afterend", gallery);
  }

  function decorateSharedPanels() {
    document.querySelectorAll(
      ".newsletter__wrapper, .collection-hero, .facets-container, .shopify-policy__container, .shopify-section[id*='contact'] .page-width"
    ).forEach((node) => {
      node.classList.add("nutravel-depth-panel");
    });
  }

  function cleanupFooterBlocks() {
    document.querySelectorAll(".footer .footer-block").forEach((block) => {
      const meaningfulText = (block.textContent || "").replace(/\s+/g, " ").trim();
      const hasMedia = block.querySelector("img, svg, iframe, form, input, button");
      const hasLinks = block.querySelector("a");
      const detailItems = block.querySelectorAll(".list-menu__item--link, .footer-block__details-content p, .footer-block__details-content li");
      const conciseText = meaningfulText.replace(/newsletter|subscribe/gi, "").trim();
      const looksEmpty = !conciseText && detailItems.length === 0;
      const headingOnly = detailItems.length === 0 && !hasMedia && meaningfulText.length > 0 && meaningfulText.length < 28;

      if ((!meaningfulText && !hasMedia && !hasLinks) || looksEmpty || headingOnly) {
        hideElement(block);
      }
    });
  }

  function bindRevealSystem() {
    if (STATE.reducedMotion || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll(
      ".nutravel-hero-scene, .nutravel-category-rail, .card-wrapper, .multicolumn-card, .product.product--small, .collection-hero, .nutravel-b2b-intro"
    ).forEach((node) => {
      node.classList.add("nutravel-reveal");
      observer.observe(node);
    });

    STATE.observers.push(observer);
  }

  function scheduleMaintenance() {
    cleanupVisualBlockers();
    cleanupOverlayBlockers();
    ensureScrollUnlocked();
    patchThemeRuntime();
    stabiliseHomepageScroll();
    bindFastRRCartBridge();
    setupFastRRObserver();
    polishFastRRDrawer();
    reconcileUpsellExperience();
    cleanupDuplicateHeroScenes();
    classifyHeroSlides();
    cleanupFooterBlocks();
    mountTrackOrderExperience();
  }

  function requestMaintenance(delay = 140) {
    if (STATE.maintenanceQueued) return;

    STATE.maintenanceQueued = true;
    if (STATE.maintenanceTimer) window.clearTimeout(STATE.maintenanceTimer);

    STATE.maintenanceTimer = window.setTimeout(() => {
      STATE.maintenanceTimer = null;
      STATE.maintenanceQueued = false;
      scheduleMaintenance();
      if (isHomepage()) mountHeroScene();
    }, delay);
  }

  function setupMaintenanceLoops() {
    if (STATE.cleanupTimer) window.clearTimeout(STATE.cleanupTimer);
    if (STATE.sceneTimer) window.clearTimeout(STATE.sceneTimer);
    if (STATE.maintenanceTimer) window.clearTimeout(STATE.maintenanceTimer);

    STATE.cleanupTimer = window.setTimeout(scheduleMaintenance, 900);
    if (isHomepage()) {
      STATE.sceneTimer = window.setTimeout(() => {
        mountHeroScene();
        cleanupDuplicateHeroScenes();
      }, 1200);
    }
  }

  function setupObservers() {
    const observer = new MutationObserver(() => {
      requestMaintenance(220);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    STATE.observers.push(observer);
  }

  function init() {
    addBodyFlags();
    cleanupVisualBlockers();
    cleanupOverlayBlockers();
    ensureScrollUnlocked();
    patchThemeRuntime();
    sanitizeVisibleTitles();
    classifyHeroSlides();
    mountHeroScene();
    mountCategoryRail();
    mountHomepageTrustStrip();
    mountHomepageManufacturingSpotlight();
    mountSalesAssist();
    hideNoisySections();
    enhanceCollectionHero();
    enhanceProductCards();
    enhanceProductPage();
    enhanceB2BPage();
    stabiliseHomepageScroll();
    bindFastRRCartBridge();
    setupFastRRObserver();
    polishFastRRDrawer();
    requestCartRefresh(60, true);
    reconcileUpsellExperience();
    mountTrackOrderExperience();
    decorateSharedPanels();
    cleanupFooterBlocks();
    bindRevealSystem();
    setupMaintenanceLoops();
    setupObservers();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
